<template>
  <div class="yy">
    <van-popup
      v-model="visible"
      round
      position="bottom"
    >
      <van-sticky>
        <div class="yy-header">
          <span>预约</span>
          <van-icon name="close" @click="visible = false" />
        </div>
      </van-sticky>
      <div class="yy-container">
        <van-cell-group class="yy-body">
          <van-cell>
            {{ item.title }} / {{ item.pricename }}
          </van-cell>
          <van-field
            v-model="signtime"
            required
            clearable
            label="预约日期"
            right-icon="clock-o"
            @click="showdate = true"
            @click-right-icon="showdate = true"
            placeholder="请选择预约日期"
            readonly
            :error="error"
          />
          <van-field
            v-model="note"
            label="留言"
            type="textarea"
            placeholder="留言内容"
            rows="1"
            autosize
          />
          <van-cell v-if="item.yyid" title="预约状态">
            <van-tag :type="yyStatusType(item.yystatus)">{{ item.yystatus == null ? '未预约' : yyStatus[item.yystatus + ''] }}</van-tag>
          </van-cell>
          <!-- <van-cell v-if="item.yyid && item.yystatus != 9">
            <van-steps :active="item.yystatus">
              <template v-for="(v, k) in yyStatus">
                <van-step v-if="k != '9'" :key="parseInt(k)">{{ v }}</van-step>
              </template>
            </van-steps>
          </van-cell> -->
          <van-cell v-if="list.length" title="预约历史" :value="list.length +' 记录'" is-link @click="showlog = true">
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell>
            <van-button block :type="item.yyid ? 'warning' : 'info'" @click="doYy">{{ item.yyid ? '重新预约' : '确定预约' }}</van-button>
            <van-button v-if="item.yyid && item.yystatus != 9" block class="btn-cancel" @click="cancelYy">取消预约</van-button>
          </van-cell>
        </van-cell-group>
      </div>
    </van-popup>
    <van-popup
      v-model="showdate"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :min-date="minDate"
        @confirm="handleChangeDate"
        @cancel="showdate = false"
      />
    </van-popup>
    <van-popup
      v-model="showlog"
      position="bottom"
    >
      <van-sticky>
        <div class="yy-header">
          <span>预约历史</span>
          <van-icon name="close" @click="showlog = false" />
        </div>
      </van-sticky>
      <div class="info">
        <van-steps direction="vertical" :active="0">
          <van-step v-for="info in list" :key="info.id">
            <div class="info-time">
              <van-tag :type="yyStatusType(info.status)">{{ yyStatus[info.status + ''] }}</van-tag>
              <span class="time">{{ info.createtime }}</span>
            </div>
            <div class="info-cons">
              <div><strong>预约日期：</strong>{{ formatDate(info.signtime) }}</div>
              <div><strong>预约留言：</strong>{{ info.note }}</div>
            </div>
          </van-step>
        </van-steps>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import { yyStatusType } from '../global';
import tools from '@/utils/tools';
export default {
  name: 'OrderYy',
  mixins: [tools],
  props: {
    item: Object
  },
  data () {
    return {
      visible: false,
      loading: true,
      list: [],
      showdate: false,
      currentDate: new Date(),
      minDate: new Date(),
      signtime: null,
      note: null,
      error: false,
      yyLoading: false,
      activeNames: ['1'],
      showlog: false,
      cancelLoading: false
    }
  },
  computed: {
    ...mapGetters({
      yyStatus: [types.STATUS.yyStatus]
    })
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      } else {
        this.showdate = false;
        this.showlog = false;
      }
    }
  },
  methods: {
    show(flag) {
      this.visible = flag;
    },
    init() {
      if (this.item.yy) {
        this.signtime = this.item.yy.signtime;
        this.currentDate = this.signtime ? this.signtime.toDate() : new Date();
        this.note = this.item.yy.note;
      }
      // 查询历史记录
      this.loadLogs();

      if (!this.yyStatus || !Object.keys(this.yyStatus).length) {
        this.$store.dispatch(types.STATUS.yyStatus);
      }
    },
    yyStatusType(status) {
      return yyStatusType(status);
    },
    loadLogs() {
      if (!this.item.yyid) {
        return;
      }
      this.loading = true;
      this.doGet({
        url: 'vue/personal/loadLogs/'+ this.item.yyid,
        okcb: (json) => {
          this.list = json;
        },
        cb: () => {
          this.loading = false;
        }
      });
    },
    // 预约
    doYy() {
      // this.visible = false;
      // this.item.yyid = 'json.id';
      //     this.item.yystatus = 2;
      //     //this.item.yy = json;
      // return;

      if (!this.signtime) {
        this.error = true;
        this.Toast('请选择预约日期！');
        return;
      }
      this.yyLoading = true;
      this.doPost({
        url: 'vue/personal/doReservation',
        data: {orderid: this.item.id, signtime: this.signtime, note: this.note, id: this.item.yyid || ''},
        okcb: (json) => {
          // 更新预约状态
          this.item.yyid = json.id;
          this.item.yystatus = json.status;
          this.item.yy = json;

          this.$emit('yy', json);
          this.visible = false;

          this.Toast.success('已提交预约！');
        },
        cb: () => {
          this.yyLoading = false;
        }
      });
    },
    cancelYy() {
      this.Dialog.confirm({
        message: `当前预约状态为【${this.yyStatus[this.item.yystatus + '']}】，确定要取消吗？`
      }).then(() => {
        this.cancelLoading = true;
        this.doPost({
          url: 'vue/personal/cancelReservation/'+ this.item.yyid,
          okcb: (json) => {
            this.item.yystatus = json.status;
            this.item.yy.status = json.status;

            this.$emit('yy', json);
            this.visible = false;

            this.Toast('已取消！');
          },
          cb: () => {
            this.cancelLoading = false;
          }
        });
      }).catch(() => {
        // on cancel
      });
    },
    handleChangeDate(val) {
      this.showdate = false;
      this.signtime = this.formatDate(val);
      this.error = false;
    }
  }
}
</script>
<style lang="less" scoped>
.btn-cancel {
  margin-top:.5rem;
}
.yy {
  &-header {
    .flex-between();
    padding:1rem;
    color:#969799;
    background-color:#fff;
    .shadow_black(0 1px 0 0, .05);
    .van-icon {
      .fontsize(1.2rem);
    }
  }
  &-body {
    max-height:60vh;
    overflow:auto;
  }
  &-container {
    .flex-column();
  }
}
.info {
  padding-bottom:2rem;
  &-time {
    .flex-between();
    .time {
      color:#777;
    }
  }
  &-cons {
    padding-top:.5rem;
    strong {
      color:#777;
    }
  }
}
</style>